<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="adresse">Complément d'adresse (nom de salle, lieu-dit, etc)*</label>
          <textarea class="form-control"
                    rows="3"
                    :id="'adresse_dojang'[dojang.id]"
                    :name="'getClub[dojang]['+dojang.id+'][complement_adresse]'"
                    v-model="dojang.complement_adresse"
                    v-validate="'max:255'"
                    placeholder="Lieu nommé du dojang...">
                                        </textarea>
          <span v-show="errors.has('dojangs['+dojang.id+'][complement_adresse]')" class="help-block">L'adresse doit comporter moins de 255 caractères</span>

        </div>

        <div class="form-group"
             :class="{'has-error': errors.has('dojangs['+dojang.id+'][adresse]') }">
          <label for="adresse">Adresse</label>
          <textarea class="form-control"
                    rows="3"
                    :id="'adresse_dojang['+dojang.id+']'"
                    :name="'getClub[dojang]['+dojang.id+'][adresse]'"
                    v-model="dojang.adresse"
                    v-validate="'max:255'"
                    placeholder="Adresse du dojang...">
                                        </textarea>
          <span v-show="errors.has('dojangs['+dojang.id+'][adresse]')" class="help-block">L'adresse doit comporter moins de 255 caractères</span>
        </div>

        <cp-and-ville
          :cpProp="dojang.cp"
          :villeProp="dojang.ville"
          placeholder_cp="Code postal du dojang"
          placeholder_ville="Ville du dojang"
          @villeChanged="setVilleDojang(dojang, $event)"
          @cpChanged="setcpDojang(dojang, $event)"
        >
        </cp-and-ville>

        <div class="form-group">
          <label for="ville">Pays</label>
          <select class="form-control"
                  :name="'getClub[dojang]['+dojang.id+'][pays]'"
                  v-model="dojang.pays">
            <option value="ZZ">Pays
              indéterminé
            </option>
            <optgroup label="Habituels">
              <option
                v-for="pays in getPays.habituels"
                :value="pays.id"
              >{{ pays.name }}
              </option>

            </optgroup>
            <optgroup label="Autres">
              <option
                v-for="pays in getPays.all"
                :value="pays.id"
              > {{ pays.name }}
              </option>
            </optgroup>
          </select>
          <!--<span class="help-block">Help block with error</span>-->
        </div>

        <div class="form-group">
          <label for="radiodea">DEA: </label>
          <label class="radio-inline">
            <input type="radio" :name="'getClub[dojang]['+dojang.id+'][dea]'"
                   id="radiodea"
                   value="1"
                   v-model="dojang.DEA">
            Oui
          </label>
          <label class="radio-inline">
            <input type="radio"
                   :name="'getClub[dojang]['+dojang.id+'][dea]'"
                   id="radiodea2"
                   value="0"
                   v-model="dojang.DEA"
            >
            Non
          </label>
        </div>

          <div class="form-group">
            <label for="deaformation">Dates de formations DEA</label>
            <table>
              <thead>
              <tr>
                <th></th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  <masked-input
                                class="form-control "
                                id="heure_debut"
                                v-model="dateDea"
                                type="text"
                                name="dateDea"
                                value=""
                                autocomplete="off"
                                :mask="[/[0-3]/,/[0-9]/, '/',/[0-1]/, /[0-9]/,'/',/[1-2]/,/[0-9]/,/[0-9]/, /[0-9]/]"
                                :guide="true"
                                :keepCharPositions="true"
                                :showMask="true">
                  </masked-input>
                </td>
                <td>
                  <button id="add_date_formation_dea" class="btn btn-primary btn-small"
                          :disabled='!isValidDate()'
                          @click.prevent="addDeaDates()">
                    Ajouter
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
            <table class="table table-hover"  v-if="dojang.DEA_formation_dates && dojang.DEA_formation_dates.length>0">
              <thead>
              <tr>
                <th>Date</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(date,index) in dojang.DEA_formation_dates">
                <td>{{ date }}</td>
                <td>
                  <button class="btn btn-box-tool" style="padding-top: 0"
                          @click.prevent="deleteDeaDate(index)">
                    <i class="fa fa-remove"></i>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>



      </div>
      <div class="col-md-6">
        <google-map
          v-show="dojang.latitude!='' && dojang.longitude!='' && dojang.latitude!=0 && dojang.longitude!=0 && dojang.latitude && dojang.longitude"
          :resize="activeTab"
          :redraw="redraw"
          :name="'dojangsname'+dojang.id+''"
          :zoom="12"
          :markerCoordinates="[{'latitude': dojang.latitude, 'longitude': dojang.longitude}]"
        >
        </google-map>
      </div>

      <div class="col-md-12">
        <div class="box box-primary" style="margin-top: 20px;">
          <div class="box-header">
            <h3 class="box-title">Horaires de ce dojang</h3>
          </div>
          <div class="box-body">
            <table class="table table-hover" style="margin-top: 10px;">
              <thead>
              <tr>
                <th>Jour</th>
                <th>De</th>
                <th>A</th>
                <th>Description</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  <select class="form-control" v-model="jour" id="jours" name="">
                    <option v-for="(jour,index) in jours"
                            :value="index"
                            :name="jour">{{ jour }}
                    </option>
                  </select>
                </td>
                <td>
                  <masked-input style="width:100px;"
                                class="form-control "
                                id="heure_debut"
                                v-model="heure_debut"
                                type="text"
                                name="heure_debut"
                                value=""
                                autocomplete="off"
                                :mask="[/[0-9]/,/[0-9]/, 'h',/[0-9]/, /[0-9]/]"
                                :guide="true"
                                :keepCharPositions="true"
                                :showMask="true">
                  </masked-input>
                </td>
                <td>

                  <masked-input style="width:100px;"
                                class="form-control heure"
                                id="heure_fin"
                                v-model="heure_fin"
                                type="text"
                                name=""
                                value=""
                                autocomplete="off"
                                :mask="[/[0-9]/,/[0-9]/, 'h',/[0-9]/, /[0-9]/]"
                                :guide="true"
                                :keepCharPositions="true"
                                :showMask="true">
                  </masked-input>
                </td>
                <td>
                  <input style="width:200px;" class="form-control" id="description" type="text"
                         v-model="description"
                         name="" value="" autocomplete="off">
                </td>
                <td>
                  <button id="add_horaire" class="btn btn-primary btn-small" @click.prevent="addHoraire()">Ajouter
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
            <table class="table table-hover" id="table-horaire">
              <thead>
              <tr>
                <th>Jour</th>
                <th>Début</th>
                <th>Fin</th>
                <th>Description</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(horaire,index) in dojang.horaires"
                  v-show="!horaire.delete">
                <td>{{ jours[horaire.jour] }}</td>
                <td>{{ horaire.debut }}</td>
                <td>{{ horaire.fin }}</td>
                <td>{{ horaire.description }}</td>
                <td>
                  <button class="btn btn-box-tool"
                          @click.prevent="deleteHoraire(horaire,index)">
                    <i class="fa fa-remove"></i>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {ErrorBag} from 'vee-validate';
import Datepicker from 'vuejs-datepicker';
import GoogleMap from '../../Communs/googleMap'
import cpAndVille from '../../Communs/cpAndVille'
import MaskedInput from 'vue-text-mask'
import moment from "moment";

var $ = require('jquery');
var _ = require('underscore')
// var moment = require('moment')
export default {
  props: {

    dojang: Object,
    activeTab: String,
    redraw: String,
  },
  methods: {
    isValidDate:function() {
      const format = "DD/MM/YYYY";
      const parsedDate = moment(this.dateDea, format, true);
      // Vérifier si la date est valide après l'analyse
      return parsedDate.isValid();
    },
    deleteHoraire: function (horaire, index) {
      // if (!_.isUndefined( this.dojang.nouveau) &&  this.dojang.nouveau)
      //     this.dojang.horaires.splice(index, 1);
      // else {
      this.$set(horaire, 'delete', true)
      // horaire.delete = true
      // }
    },
    addHoraire: function () {
      let horaire = {
        debut: this.heure_debut,
        description: this.description,
        fin: this.heure_fin,
        id_dojang: this.dojang.id,
        jour: this.jour,
        nouveau: true
      }
      this.dojang.horaires.push(horaire)
    },
    addDeaDates: function () {
      if (this.dojang.DEA_formation_dates === null || this.dojang.DEA_formation_dates === undefined)
        this.dojang.DEA_formation_dates = []

      if(!this.isValidDate())
        return

      this.dojang.DEA_formation_dates.push(this.dateDea)
    },
    deleteDeaDate: function (index) {
      this.dojang.DEA_formation_dates.splice(index, 1);
    },
    resetFormAddHoraire: function () {
      this.jour = 1
      this.heure_debut = ""
      this.heure_fin = ""
      this.description = ""
    },
    setVilleDojang(dojang, value) {
      dojang.ville = value
    },
    setcpDojang: function (dojang, value) {
      dojang.cp = value
    },
  },
  data: function () {
    return {
      jour: 1,
      heure_debut: "",
      heure_fin: "",
      description: "",
      dateDea: "",
      jours: {
        1: "Lundi",
        2: "Mardi",
        3: "Mercredi",
        4: "Jeudi",
        5: "Vendredi",
        6: "Samedi",
        7: "Dimanche"
      }
    }
  },
  created: function () {
    this.resetFormAddHoraire();
  },
  watch: {},
  mounted: function () {
  },
  components: {
    GoogleMap,
    cpAndVille
  },
  computed: {
    ...mapGetters({
      getVilles: 'getVilles',
      getPays: 'getPays',
      getClub: 'getClub'
    }),
  },

};
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Club/Dojang.vue